import { AnyAction } from 'redux'

interface FilterRoleNameState {
  name: string
}

const noFilterRoleName: FilterRoleNameState = {
  name: '',
}

const filterRoleName = (state = noFilterRoleName, action: AnyAction) => {
  switch (action.type) {
    case 'SET_FILTER_ROLE_NAME':
      const newState = {
        name: action.name,
      }

      return {
        ...state,
        ...newState,
      }

    default:
      return state
  }
}

export default filterRoleName
